/**
 * 전자계약 창구의 **버전 없는 고정 주소**.
 *
 * 왜 있는가 (2026-09-23):
 * 창구를 v1 → v2 → v3 → v5 로 옮길 때마다 같은 사고가 반복됐다. 화면마다 `/v3/contract/types`
 * 처럼 **버전이 박힌 주소**를 직접 push 하고 있어서, 창구를 옮기면 43곳을 사람이 전수로 찾아
 * 고쳐야 했다. 하나라도 놓치면 사용자는 새 창구로 들어왔다가 구 창구로 빠지고, 거기서
 * **구 서식으로 계약을 발행**하게 된다(실제로 v5 전환 점검에서 5종 작성 화면의 「취소」가
 * 전부 v3 로 돌아가는 것이 발견됐다).
 *
 * 게다가 메뉴는 DB(`menus.link`), 화면은 코드라 축이 둘로 갈려 있었다. 한쪽만 바꾸면
 * 조용히 불일치가 생긴다.
 *
 * 그래서 **주소에서 버전을 없앤다.**
 *   - 화면·메뉴·서버·앱은 전부 이 고정 주소만 쓴다. 버전을 모른다.
 *   - 고정 주소는 라우터에서 현재 창구 라우트의 **별칭(alias)** 으로 붙인다
 *     (`src/router/index.js` 의 `CONTRACT_LIST_PATH` / `CONTRACT_TYPES_PATH` 사용처).
 *   - 창구를 교체할 때 바꾸는 곳은 그 별칭 두 줄뿐이다. 메뉴 DB·서버·화면은 건드리지 않는다.
 *
 * [HARD] 화면 코드(`src/views/**`)에 `/v1|/v2|/v3|/v5 + /contract/...` 리터럴을 다시 쓰지 않는다.
 * `scripts/contract-console-path-check.js` 가 그것을 검사해 실패시킨다(라우트 정의만 예외).
 *
 * 왜 redirect 가 아니라 alias 인가:
 * redirect 면 주소가 `/v5/contract/list` 로 바뀌어, 메뉴 DB 의 link(`/contract/list`)와 달라져
 * 사이드바 활성 표시가 풀린다(활성 판정이 `$route.path` 비교다 —
 * `views/components/Sidenav/SidenavList.vue`). alias 는 주소를 그대로 두므로 둘이 계속 일치한다.
 */

/** 전자계약 목록 — 메뉴(`menus.link`)·앱 착지·서버 복귀 주소가 가리키는 값과 같아야 한다. */
export const CONTRACT_LIST_PATH = '/contract/list';

/** 계약 유형 선택(신규 계약) — 작성 화면의 「취소」가 돌아오는 곳. */
export const CONTRACT_TYPES_PATH = '/contract/types';
